import { useDispatch } from 'react-redux';
import { events, apiEvents } from 'utils/Api/Api';
import { RootDispatch } from 'storage/store';
import {
  AgreementWaitingForContract,
  ContractsAvailability,
  ProductOfferAvailability
} from 'storage/agreements/agreements.model';

const TRANSFORM_CONTRACT_DATA = (product: ContractsAvailability) =>
  Object.entries(product).map(
    ([key, value]: [string, ProductOfferAvailability]) => ({
      agreementId: Number(key),
      productAvailable: value.offer,
      annexAvailable: value.annex
    })
  );
const WebSocketsEvents = () => {
  const dispatch = useDispatch<RootDispatch>();

  events.on(apiEvents.WSS_DOCUMENT_GENERATION, (agreements) => {
    const { data } = agreements as { data: AgreementWaitingForContract[] | [] };
    dispatch.agreements.storeAgreementsWaitingForContract(
      data as AgreementWaitingForContract[]
    );
  });

  events.on(apiEvents.WSS_CLIENT_DATA_SYNCHRONIZED, (message) => {
    dispatch.application.storeDataSynchronized(message as boolean);

    setTimeout(() => {
      dispatch.application.storeDataSynchronized(null);
    }, 0);
  });

  events.on(apiEvents.WSS_PRODUCT_OFFER, (agreements) => {
    const agreementsObject = agreements as {
      newData: ContractsAvailability;
    };
    dispatch.contractsAgreements.storeAgreementsWithProductAvailability(
      TRANSFORM_CONTRACT_DATA(agreementsObject.newData)
    );
  });
};

export default WebSocketsEvents;
